var layout_default = {
  "layout": "_7R4i-",
  "cell": "NRlaJ"
};
export {
  layout_default as default
};
//# sourceMappingURL=layout-scss.js.map
